import React, {} from 'react';

function ToggleListBody(props) {

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: 'toggle-list-body',
      style: {
        display: 'block'
      }
    };

    if (props.element.properties.collapsed === true) {
      attributes.style.display = 'none';
    }

    return <div {...attributes}>
      {props.children}
    </div>;

  }

  return renderMain();

}

export default ToggleListBody;